import { render } from "./OrdersV2.vue?vue&type=template&id=785af774&scoped=true"
import script from "./OrdersV2.vue?vue&type=script&lang=ts"
export * from "./OrdersV2.vue?vue&type=script&lang=ts"

import "./OrdersV2.vue?vue&type=style&index=0&id=785af774&scoped=true&lang=css"
import "./OrdersV2.vue?vue&type=style&index=1&id=785af774&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-785af774"

export default script